export default function http(url, {
  headers, data, form,
  ...options
} = {}) {
  const requestHeaders = {
    Accept: 'application/json',
    ...headers,
  };

  if (data) {
    options.body = JSON.stringify(data);
    requestHeaders['Content-Type'] = 'application/json';
  }

  if (form) {
    options.body = form;
  }

  if (http.token) {
    requestHeaders.Authorization = `bearer ${http.token}`;
  }

  if (http.local) {
    requestHeaders['X-localization'] = http.local.code;
  }

  if (http.lang) {
    requestHeaders['X-lang'] = http.lang.id;
  }

  if (http.store) {
    http.store.dispatch('setOverlay', true);
  }

  return fetch(`${process.env.VUE_APP_API_URL}${url}`, {
    headers: requestHeaders,
    ...options,
  }).then((response) => response.json().then((body) => ({
    body,
    status: response.status,
  }))).then((response) => {
    if (http.store) {
      http.store.dispatch('setOverlay', false);
    }

    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    if (!http.onError(response)) {
      throw new Error(response.body.message || response.body.errors.join('\n'));
    }
  });
}

http.onError = () => {};
